import { createSvgIcon } from '@mui/material';

export const LassoSelectClear = createSvgIcon(
  <>
    <rect
      x="6"
      y="5.5"
      width="13"
      height="12"
      stroke="currentColor"
      strokeDasharray="2 2"
      fill="none"
    />
    <path
      d="M5 4.5L19.4999 17.9394"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </>,
  'LassoSelectClear',
);
